



























































































































































































































import { Component, Vue, Emit, Prop, Ref, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import { TipoDocumentoUpload } from '@/types/_'

import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentBackofficeCotacaoOperadora extends Vue {
  @Prop({ required: true }) disabled: boolean
  @Prop({ required: false, default: true }) showBtn: boolean
  @Prop({ required: false, default: false }) disableBtn: boolean
  @Prop({ required: false, default: '' }) errorMessage: string

  $refs!: {
    cotacaoOperadora: any,
  }

  cotacaoOperadoraRules: any = {
    valid: false,
    valor: [
      v => this.validate(v) || 'O valor é obrigatório.',
    ],
  }

  validate(v: any) {
    return parseFloat(v) > 0
  }

  load: boolean = false
  delLoad: string = ''
  laudos: any[] = []
  filesCotacaoOperadora: any[] = []

  get operadoraAviso() {
    /*
      SE OPER_CODIFICACAO = SIM

      TEXTO = "Operadora exige codificação do material"

      SE SETOR_HOSPITAL = "CENTRAL"
      TEXTO = TEXTO & ", que será realizado pela Central de Guias do Hospital."
      SENÃO
      TEXTO = TEXTO & ", que será realizado pelo Setor de Suprimentos do Hospital."

      SENÃO
      TEXTO = "Operadora não exige codificação do material."


      exibe TEXTO
    */

    const { convenioNome, convenioExigeCodificacaoOpme } = this.getBackofficeGlobalStore.solicitacao!
    const textoBase = `Operadora ${convenioNome} exige codificação de material.`

    return convenioExigeCodificacaoOpme ? textoBase : `Operadora ${convenioNome} não exige codificação do material.`
  }

  get loading() {
    return this.load
  }

  set loading(value: boolean) {
    this.load = value
  }

  get delLoading() {
    return this.delLoad
  }

  set delLoading(value: string) {
    this.delLoad = value
  }

  get getLaudos() {
    if (this.getBackofficeGlobalStore.solicitacao.laudos) {
      return this.getBackofficeGlobalStore.solicitacao.laudos.filter(c => c.tipoDocumento === 'CotacaoOpme')
    }

    return []
  }

  set getLaudos(value) {
    this.getBackofficeGlobalStore.setLaudos(value)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get getShowModal() {
    return this.getBackofficeGlobalStore
  }

  async deleteLaudo(value) {
    this.delLoading = value.id
    const request = await this.getBackofficeGlobalStore.deleteLaudo({
      hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      id: value.id,
    })
    if (request.success) {
      if (request.success) {
        const removeArray: any[] = []

        for (let i = 0; i < this.getLaudos.length; i++) {
          if (this.getLaudos[i].identifier === value.identifier) {
            removeArray.push(i)
          }
        }

        for (let i = 0; i < removeArray.length; i++) {
          this.getLaudos.splice(removeArray[i], 1)
        }
      }
    }
    this.delLoading = ''
  }

  async inputFileCotacaoOperadora(newFile, oldFile) {
    if (newFile.identifier) {
      return
    }

    EventBus.$emit('loadingAnexoRespotaCotacao', true)

    const form = new FormData()
    form.append('laudos', newFile.file)

    const request = await this.getBackofficeGlobalStore.uploadCotacaoOperadora(form)

    // eslint-disable-next-line no-param-reassign
    newFile.identifier = request.data[0].id
    // eslint-disable-next-line no-param-reassign
    newFile.id = request.data[0].id
    // eslint-disable-next-line no-param-reassign
    newFile.url = request.data[0].url
    // eslint-disable-next-line no-param-reassign
    newFile.nomeOriginalArquivo = request.data[0].nomeOriginalArquivo
    // eslint-disable-next-line no-param-reassign
    newFile.tipoDocumento = TipoDocumentoUpload.CotacaoOpme
    this.getLaudos = newFile

    EventBus.$emit('loadingAnexoRespotaCotacao', false)
  }

  get faturamento() {
    // @ts-ignore
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.faturamentoDiretoComOperadora
      : false
  }

  set faturamento(value: boolean) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoFaturamento(value)
  }

  get comentarios() {
    // @ts-ignore
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.comentarios
      : ''
  }

  set comentarios(value: string) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoComentarios(value)
  }

  get notaFiscal() {
    // @ts-ignore
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.notaFiscal
      : false
  }

  set notaFiscal(value: boolean) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoNotaFiscal(value)
  }

  get observacao() {
    // @ts-ignore
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.observacao
      : 'Outros'
  }

  set observacao(value: string) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoObservacao(value)
  }

  get cotacaoComUrgencia() {
    // @ts-ignore
    return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo
      ? this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.cotacaoComUrgencia
      : false
  }

  set cotacaoComUrgencia(value: boolean) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoCotacaoComUrgencia(value)
  }

  get valor() {
    if (this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo) {
      return this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.valor === null ? 0 : this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo.valor
    }
    return 0
  }

  set valor(value: string | number | null) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoValor(value)
  }

  setLoading(value:boolean) {
    this.loading = value
  }

  mounted() {
    EventBus.$on('loadingAnexoRespotaCotacao', value => this.setLoading(value))
  }
}
